"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { HeroButtonsProps } from "@/types/components";

export default function HeroButtons({ buttons }: HeroButtonsProps) {
  
  const defaultButtons = [
    { text: "Get started", url: "#" },
    { text: "Discover more", url: "#" },
  ];

  const buttonData = buttons && buttons.length > 0 ? buttons : defaultButtons;

  return (
    <div className="flex flex-row gap-4 justify-center items-center">
      {buttonData.map((button, index) => (
        <Link
          key={index}
          href={button.url || "#"}
          className={`max-sm:text-sm inline-flex items-center justify-center max-sm:!px-[16px] py-3  sm:px-8 sm:py-4 font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 ${
            index === 0
              ? "cta-button-primary bg-accent text-white hover:bg-orange-hover relative overflow-hidden group"
              : "items-center justify-center w-fit group bg-white-transparent text-white border border-white/20 bg-white/10 hover:shadow-lg hover:shadow-white/10 relative overflow-hidden"
          }`}
        >
          <span className="transition-all duration-300 text-white group-hover:text-white">
            {button.text}
          </span>
          {index === 1 && (
            <ArrowRight className="h-3.5 w-3.5 ml-2 transition-all duration-300 group-hover:translate-x-1 group-hover:scale-110 text-white shrink-0" />
          )}
          {index === 1 && (
            <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-500 ease-out bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
          )}
        </Link>
      ))}
    </div>
  );
}
